var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPosts2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M9.34136 15.7373C9.03793 16.1007 9.08764 16.6407 9.45108 16.9442C9.81451 17.2476 10.3554 17.1979 10.6579 16.8344L14.9437 12.5487C14.978 12.5084 14.9943 12.4604 15.02 12.4158C15.0406 12.3807 15.0646 12.3498 15.08 12.3112C15.1194 12.211 15.1426 12.1064 15.1426 12.0001C15.1426 11.8938 15.1194 11.7892 15.08 11.689C15.0646 11.6504 15.0406 11.6195 15.02 11.5844C14.9943 11.5398 14.978 11.4918 14.9437 11.4515L10.6579 7.16575C10.3554 6.80146 9.81451 6.7526 9.45108 7.05603C9.08764 7.35861 9.03793 7.89862 9.34136 8.26291L12.4554 11.1429L13.3125 12L12.4533 12.8592L9.34136 15.7373Z",
    fill: "#5367FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts2);
export default __webpack_public_path__ + "static/media/posts2.29d33fda6af5abeae61965ae3e5add14.svg";
export { ForwardRef as ReactComponent };